import React, { useContext, useState, useEffect } from 'react'
import { auth,db } from '../firebase'
import { onAuthStateChanged, signInWithEmailAndPassword, 
    signOut, GoogleAuthProvider, signInWithPopup, sendPasswordResetEmail, signInWithPhoneNumber } from 'firebase/auth'
import { getFirestore, doc, setDoc, getDoc, updateDoc } from 'firebase/firestore';
import { resolveAccess, AccessDeniedError } from '../access/access';

const AuthContext = React.createContext()
const googleProvider = new GoogleAuthProvider();

export function useAuth() {
    return useContext(AuthContext)
}

export function AuthProvider ({ children }){
    const [currentUser,setCurrentUser] = useState()
    const [access,setAccess] = useState({ isAdmin: false, isFixedAdmin: false })
    const [accessError,setAccessError] = useState("")
    const [loading,setLoading] = useState(true)

    
    async function googleLogin(){
        try{
            const userCredential = await  signInWithPopup(auth, googleProvider);
            const user = userCredential.user;
            // console.log(user);
            // add user to firestore
            const db = getFirestore();
            const userDocRef = doc(db, 'users', user.uid);
            const userDocSnap = await getDoc(userDocRef);

            if(!userDocSnap.exists()){ 
                // User doesn't exist, create a new document
                const docSetStatus = await setDoc(userDocRef, {
                    uid: user.uid,
                    email: user.email,
                    name: user.displayName,
                    createdAt: new Date(),
                    image_url: user.photoURL,
                    provider: "2"
                });
            }
            else{
                // User exists, update the document
                const docUpdateStatus = await updateDoc(userDocRef, {
                    email: user.email,
                    name: user.displayName,
                    image_url: user.photoURL,
                    provider: "2"
                });
            }
        } catch(err){
            window.alert(err.message)
        }
    }
    function login(email,password){
        return signInWithEmailAndPassword(auth, email,password)
    }
    async function phoneLoginGetCofirmationResult(phoneNumber) {
        const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, window.recaptchaVerifier)
        window.confirmationResult = confirmationResult;
        return confirmationResult
        // .then((confirmationResult) => {
        //     // SMS sent. Prompt user to type the code from the message, then sign the
        //     // user in with confirmationResult.confirm(code).
        //     window.confirmationResult = confirmationResult;
        //     confirmationResult.confirm(code).then((result) => {
        //         console.log(result)
        //     })
        // })
    }
    async function phoneLoginWithOtp(confirmationResult, otp,mobile){
        const result = await confirmationResult.confirm(otp)
        const user = result.user;
        const db = getFirestore();
        
        const userDocRef = doc(db, 'users', user.uid);
        try {
            // Check if the document with the given UID already exists
            const docSnapshot = await getDoc(userDocRef);
        
            if (!docSnapshot.exists()) {
              // Document does not exist, create a new document
              const docSetStatus = await setDoc(userDocRef, {
                uid: user.uid,
                mobile: mobile,
                createdAt: new Date(),
                provider: "1",
              });
            }
          } catch (error) {
            console.error("Error checking document existence or creating document:", error);
          }

        return result
    }
    function sendResetPasswordEmail(email){
        return sendPasswordResetEmail(auth, email);
    }
    function logout(){
        return signOut(auth);
    }
    useEffect(()=>{
        // Only members on the allowlist (or admins) stay signed in while the product is in testing.
        const unsubscribe = onAuthStateChanged(auth, async user => {
            if (!user) {
                setCurrentUser(null)
                setAccess({ isAdmin: false, isFixedAdmin: false })
                setLoading(false)
                return
            }
            try {
                setAccess(await resolveAccess(user))
                setAccessError("")
                setCurrentUser(user)
            } catch (err) {
                setAccessError(err instanceof AccessDeniedError ? err.message : "Couldn't check your access. Please try again.")
                setCurrentUser(null)
                await signOut(auth)
            }
            setLoading(false)
        })

        return unsubscribe
    },[])

    const value = {
        currentUser,
        isAdmin: access.isAdmin,
        isFixedAdmin: access.isFixedAdmin,
        accessError,
        clearAccessError: () => setAccessError(""),
        login,
        googleLogin,
        sendResetPasswordEmail,
        phoneLoginGetCofirmationResult,
        phoneLoginWithOtp,
        logout
    }
    return(
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}